import React from "react";
import { Box, Heading } from "@chakra-ui/react";
import { MIGRATION_CONSTANTS } from "./constants";
import AdvantageCardList from "@/components/advantageCard";

const MigrationCta = () => {
  return (
    <Box px={{ md: 16 }}>
      <Heading as="h2" fontWeight={"400"} textAlign={"center"} fontSize={"40px"} mb={12}>
        {MIGRATION_CONSTANTS.title}
      </Heading>
      <AdvantageCardList
        items={MIGRATION_CONSTANTS.items}
        bgColor="#F9FAFC"
        hoverEffect
      />
    </Box>
  );
};

export default MigrationCta;
